<template>
    <div class="org-tree">
      <el-input
        size="small"
        type="text"
        clearable
        class="search-input"
        v-model="keywords"
        @input="searchUser"
        @clear="searchUser"
        placeholder="输入姓名、昵称、备注、电话、通号"
        title="输入姓名、昵称、备注、电话、通号"
      ></el-input>
      <div class="tree-wrap" v-show="!showSearch">
        <el-tree
          node-key="TreeID"
          :props="treeProps"
          :default-expanded-keys="defaultExpend"
          :indent="8"
          ref="tree"
          lazy
          :load="loadTree"
        >
          <div
            class="tree-node text-ellipsis"
            :title="data.Name"
            :class="treeStateClass(data)"
            slot-scope="{ node, data }"
          >
            <div class="org-username">
              <user-icon :logoPath="data.BeUserLogo || data.UserLogo"></user-icon>
              <span>{{data.Name}}</span>
            </div>
            
            <span
              class="authorized-btn"
              v-if="data.hasOwnProperty('CompID') && data.CanSelect"
              @click.stop="rowSelect(data)"
            >
              <i
                v-if="treeSelectedIndex(data) === -1"
                class="author-btn el-icon-circle-plus-outline"
              >选择</i>
              <i v-else class="author-btn el-icon-remove-outline">取消</i>
            </span>
          </div>
        </el-tree>
      </div>
      <!-- 搜索结果 -->
      <div class="search-box" v-show="showSearch" v-loading="searchLoading">
        <ul v-for="grop in searchGroup" :key="grop.name">
          <li class="grop-title">{{grop.name}}</li>
          <li
            class="user-item text-ellipsis"
            v-for="item in grop.list"
            :key="item.DID"
            :title="item.Name"
            :class="treeStateClass(item)"
          >
            <div class="org-username">
              <user-icon :logoPath="item.BeUserLogo || item.UserLogo"></user-icon>
              <span>{{item.Name}}</span>
            </div>
            <span class="authorized-btn" @click.stop="rowSelect(item)" v-if="item.hasOwnProperty('CompID') && item.CanSelect">
              <i
                v-if="treeSelectedIndex(item) === -1"
                class="author-btn el-icon-circle-plus-outline"
              >选择</i>
              <i v-else class="author-btn el-icon-remove-outline">取消</i>
            </span>
          </li>
        </ul>
        <div class="user-no-data" v-show="!searchLoading && searchGroup.length === 0">暂无数据</div>
      </div>
    </div>
  </template>
<script>
import {Category,WinForm} from '@digital-supply-chain/module'
import {ApiService,DataService,UserService,AuthService,OrgService} from '@/service'
import {UtilService} from '@/libs'

import UserIcon from '/@/components/icon/user-icon.vue';

const { CompID, CompName } = UserService.user();

  export default {
    props: {
      selectedList: {
        type: Array,
        required: true
      },
      onlyComp: false,
      selectComp: {
        type: Boolean,
        default: true
      },
      selectDepart: {
        type: Boolean,
        default: true
      },
      selectUser: {
        type: Boolean,
        default: true
      }
    },
    components: {UserIcon},
    data() {
      return {
        keywords: "",
        searchData: {
          orgs: {
            name: CompName,
            list: []
          },
          contact: {
            name: "联系人",
            list: []
          },
          recent: {
            name: "最近联系人",
            list: []
          }
        },
        showSearch: false,
        searchLoading: false,
        chatList: null,
        defaultExpend: this.onlyComp ? [`${CompID}|0|0`] : [],
        defaultNodes: [
          {
            TreeID: `contacts`,
            Name: "联系人",
            isLeaf: false
          },
          {
            TreeID: `recentUser`,
            Name: "最近联系人",
            isLeaf: false
          }
        ],
        treeProps: {
          isLeaf: "isLeaf"
        },
        defaultUserLogo: require("../../assets/images/nousericon.png")
      };
    },
    computed: {
      searchGroup() {
        return Object.values(this.searchData).filter(
          item => item.list.length > 0
        );
      }
    },
    methods: {
      async loadTree(node, resolve) {
        if (node.level === 0) {
          let defaultTrees = await this.getDefaultNode();
          resolve(defaultTrees);
        } else {
          const { TreeID, Type, OrgID, children } = node.data;
          switch (TreeID) {
            case "contacts":
              resolve(await this.getContactGroup());
              break;
            case "recentUser":
              resolve(await this.getRecentUser());
              break;
            case "subComp":
              resolve(children);
              break;
            case "group":
              resolve(children);
              break;
            default:
              if (Type === "contact") {
                resolve(await this.getContacts(OrgID));
              } else {
                resolve(await this.getOrgAndUser(OrgID));
              }
              break;
          }
        }
      },
      async getDefaultNode() {
        let defaultTrees = [];
        let config = WinForm.storge.get("comp-config");
  
        // isSpecial or AllowShareArea为1时 不显示联系人 仅可选择组织架构 分子公司 集团公司
        if (!this.onlyComp && !(config && config.AllowShareArea === 1)) {
          defaultTrees.push(...this.defaultNodes);
        }
  
        if (CompID > 0) {
          defaultTrees.push({
            TreeID: `${CompID}|0|0`,
            CompID,
            OrgID: 0,
            UserID: 0,
            CanSelect: true,
            CompName,
            Name: CompName,
            isLeaf: false
          });
          if (!this.onlyComp) {
            let promiseArr = [
              AuthService.getSubComps(CompID),
              AuthService.getGroupComps(CompID)
            ];
            const [subComps, groupComps] = await Promise.all(promiseArr);
            if (subComps.length > 0) {
              subComps.forEach(item => {
                item.CanSelect = this.selectComp;
              });
              defaultTrees.push({
                TreeID: "subComp",
                Name: "分/子公司",
                children: this.setTreeID(subComps),
                isLeaf: false
              });
            }
            if (groupComps.length > 0) {
              groupComps.forEach(item => {
                item.CanSelect = this.selectComp;
              });
              defaultTrees.push({
                TreeID: "group",
                children: this.setTreeID(groupComps),
                Name: "所在集团",
                isLeaf: false
              });
            }
          }
        }
        return defaultTrees;
      },
      setTreeID(list) {
        list.forEach(item => {
          item.TreeID = `${item.CompID}|${item.OrgID}|${item.UserID}`;
        });
        return list;
      },
      treeStateClass(data) {
        let index = this.treeSelectedIndex(data);
        return index > -1 ? "tree-selected" : "";
      },
      // treeNode是否已选择
      treeSelectedIndex(data) {
        let index = -1;
        if (data.UserID > 0) {
          index = this.selectedList.findIndex(item => item.UserID == data.UserID);
        } else {
          index = this.selectedList.findIndex(
            item =>
              item.OrgID == data.OrgID &&
              item.UserID == data.UserID &&
              item.CompID == data.CompID
          );
        }
        return index;
      },
      // 选择人 获取人员信息
      async rowSelect(data) {
        let needInfo = ["contact", "recent"].includes(data.Type);
        if (needInfo && !data.Loaded) {
          let userinfo = await DataService.get(
            `${ApiService.JrzzApi}/user/getuserinfo?userId=${data.UserID}`
          );
          data.OrgID = userinfo.OrgID;
          data.CompID = userinfo.CompID;
          data.OrgName = userinfo.OrgName || "";
          data.CompName = userinfo.CompName || "";
          data.Loaded = true;
        }
        let index = this.treeSelectedIndex(data); // 是否存在
        this.$emit("toggleClick", data, index);
      },
      // 获取搜索数据
      searchUser: UtilService.Debounce(function() {
        if (this.keywords === "") {
          this.showSearch = false;
        } else {
          this.showSearch = true;
          this.searchLoading = true;
  
          if (this.onlyComp) {
            this.getAllUser().then(list => {
              this.searchData.orgs.list = list;
              this.searchLoading = false;
            });
          } else {
            let promiseArr = [
              OrgService.getAddressBook(this.keywords),
              this.getRecentUser()
            ];
            if (CompID > 0) {
              promiseArr.push(this.getAllUser());
            }
            Promise.all(promiseArr).then(([contacts, recentUser, orgUsers]) => {
              // 联系人搜索
              this.searchData.contact.list = this.formateContact(contacts);
              // 最近联系人过滤
              this.searchData.recent.list = recentUser.filter(recent => {
                return recent.Name.indexOf(this.keywords) !== -1;
              });
              // 本企业人员
              if (orgUsers) this.searchData.orgs.list = orgUsers;
  
              this.searchLoading = false;
            });
          }
        }
      }, 500),
      // 获取组织架构
      async getOrgAndUser(orgId) {
        let res = await AuthService.getOrgs(orgId, CompID);
        res.forEach(item => {
          item.CanSelect = item.UserID > 0 ? this.selectUser : this.selectDepart;
        });
        return this.setTreeID(res);
      },
      // 获取本组织所有人员
      async getAllUser() {
        let res = await OrgService.getUsers(this.keywords);
        res.List.forEach(item => {
          item.Name = item.UserName;
          item.CompID = CompID;
          item.CanSelect = this.selectUser;
          item.CompName = CompName;
        });
        return this.setTreeID(res.List);
      },
      // 联系人分组
      async getContactGroup() {
        let groupList = await OrgService.getContactGroup();
        let list = groupList.map(item => {
          return {
            OrgID: item.DirID,
            UserID: 0,
            Name: item.DirName,
            Type: "contact",
            isLeaf: false
          };
        });
        return this.setTreeID(list);
      },
      // 获取联系人
      async getContacts(orgId) {
        let res = await OrgService.getContacts(orgId);
        return this.formateContact(res);
      },
      // 获取最近联系人
      async getRecentUser() {
        if (this.chatList) return this.chatList; // 已经调取过接口后不再调用；
  
        let res = await OrgService.getRecentUser().then(res => {
          return res.filter(item => item.SessionCategoryID === Category.User);
        });
        let list = res.map(item => {
          return {
            Name: item.SessionName,
            CompID: 0,
            OrgID: 0,
            UserID: item.SessionDataID,
            CanSelect: this.selectUser,
            CompName: "",
            OrgName: "",
            UserName: item.SessionName,
            Type: "recent",
            UserLogo: item.SessionLogo,
            isLeaf: true
          };
        });
        this.chatList = this.setTreeID(list);
        return this.chatList;
      },
      // 补全联系人数据
      formateContact(list) {
        let formate = list.map(item => {
          let username = item.UserRemark || item.UserName;
          return {
            Name: username,
            CompID: 0,
            OrgID: 0,
            UserID: item.UserID,
            CompName: "",
            OrgName: "",
            CanSelect: this.selectUser,
            UserName: username,
            Type: "contact",
            UserLogo: item.UserLogo,
            isLeaf: true
          };
        });
        return this.setTreeID(formate);
      }
    }
  };
  </script>
  
  <style lang="less" scoped>
  .org-tree {
    height: 100%;
    width: 271px;
    background-color: #fff;
    font-size: 1.4rem;
    border-right: 1px solid #e5e7ec;
    display: flex;
    flex-direction: column;
    user-select: none;
    .search-input {
      margin: 8px;
      width: auto;
    }
    .tree-wrap {
      flex: 1;
      overflow: hidden;
      &:hover {
        overflow: auto;
      }
    }
  
    .node-icon {
      margin-right: 4px;
    }
    .user-logo {
      width: 18px;
      height: 18px;
      margin-top: 4px;
      margin-right: 4px;
      vertical-align: middle;
    }
  
    .authorized-btn {
      display: none;
      position: absolute;
      right: 6px;
      top: 3px;
      font-size: 12px;
      line-height: 18px;
      cursor: pointer;
      padding: 0 4px;
      z-index: 3;
      border-radius: 3px;
      border: 1px solid #bebec1;
      background-color: #fff;
      color: #333;
  
      .author-btn {
        &::before {
          margin-right: 2px;
        }
      }
    }
  
    .tree-node {
      display: inline-block;
      width: 100%;
      height: 26px;
      color: #333;
      line-height: 26px;
      padding-right: 10px;
      position: relative;
  
      &:hover {
        .authorized-btn {
          display: block;
        }
      }
  
      &.tree-disabled {
        color: #c1c1c1;
  
        .node-icon {
          color: #c1c1c1;
        }
  
        .authorized-btn {
          display: none;
        }
      }
    }
    .search-box {
      padding-bottom: 4px;
      color: #333;
      overflow: hidden;
      height: 100%;
      &:hover {
        overflow: auto;
      }
      .grop-title {
        font-size: 14px;
        padding: 5px 0 5px 14px;
        line-height: 24px;
        margin-top: 4px;
        background-color: #f5f7fa;
      }
    }
  
    .user-item {
      padding-left: 14px;
      line-height: 26px;
      padding-right: 10px;
      position: relative;
      cursor: pointer;
      &:hover {
        background-color: #eee;
        .authorized-btn {
          display: block;
        }
      }
    }
    .tree-selected {
      color: #5D96F7;
      .authorized-btn {
        color: #5D96F7;
        border-color: #5D96F7;
      }
    }
    .user-no-data {
      color: #999;
      text-align: center;
      line-height: 60px;
    }
  }
  /deep/ .el-tree-node__content {
    position: relative;
    cursor: default;
  }
  /deep/ .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background-color: #f5f7fa;
  }

  .org-username{
    font-size: 14px;
    color: @main-color;
    display: flex;
    align-items: center;
    /deep/ img{
      width: 18px;
      height: 18px;
      margin-right: 4px;
    }
  }
  </style>